module.exports = __webpack_public_path__ + "img/closed.6bc52171.png";